// export const regionConfig = {
//   US: {
//     aws_project_region: "us-west-2",
//     aws_cognito_region: "us-west-2",
//     aws_user_pools_id: "us-west-2_Vz5tDjg3y",
//     aws_user_pools_web_client_id: "5lj1cimcdk1p89r20ecpcqdh3b",
//     oauth: {
//       domain: "https://us-west-2vz5tdjg3y.auth.us-west-2.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://support.servqualit.com/",
//       redirectSignOut: "https://support.servqualit.com/",
//     },
//   },
//   IN: {
//     aws_project_region: "ap-south-1",
//     aws_cognito_region: "ap-south-1",
//     aws_user_pools_id: "ap-south-1_nbQYwCpEz",
//     aws_user_pools_web_client_id: "5tekknmkii3lpsamv4tasmd3ru",
//     oauth: {
//       domain: "https://ap-south-1nbqywcpez.auth.ap-south-1.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://support.servqualit.com/",
//       redirectSignOut: "https://support.servqualit.com/",
//     },
//   },
//   GB: {
//     aws_project_region: "eu-west-1",
//     aws_cognito_region: "eu-west-1",
//     aws_user_pools_id: "eu-west-1_t8wtScXyc",
//     aws_user_pools_web_client_id: "50me4qr8qje2pbp7nckaav7a9b",
//     oauth: {
//       domain: "https://eu-west-1t8wtscxyc.auth.eu-west-1.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://support.servqualit.com/",
//       redirectSignOut: "https://support.servqualit.com/",
//     },
//   },
// };

// // Order here is the order they appear in the picker.
// export const REGIONS = [
//   { code: "GB", label: "United Kingdom", detail: "eu-west-1" },
//   { code: "US", label: "United States", detail: "us-west-2" },
//   { code: "IN", label: "India", detail: "ap-south-1" },
// ];

// export const DEFAULT_REGION = "GB";

// /**
//  * Derived from regionConfig[*].oauth.domain (host only, no https://).
//  * Keep in sync whenever you add, remove, or rename a pool.
//  */
// const domainToRegionMap = {
//   "us-west-2vz5tdjg3y.auth.us-west-2.amazoncognito.com": "US",
//   "ap-south-1nbqywcpez.auth.ap-south-1.amazoncognito.com": "IN",
//   "eu-west-1t8wtscxyc.auth.eu-west-1.amazoncognito.com": "GB",
// };

// // AWS region -> business region. Unambiguous here (one pool per AWS region).
// const awsToBusinessRegionMap = {
//   "us-west-2": "US",
//   "ap-south-1": "IN",
//   "eu-west-1": "GB",
// };

// // Sticky, authoritative choice — survives the Cognito redirect and browser restarts.
// const ORIGINAL_KEY = "userOriginalRegion";
// // Per-session mirror, kept for anything that still reads the old key.
// const SESSION_KEY = "userRegion";

// const isKnownRegion = (code) => !!code && !!regionConfig[code];

// const persistRegion = (code) => {
//   try {
//     localStorage.setItem(ORIGINAL_KEY, code);
//   } catch {
//     /* private mode / storage disabled */
//   }
//   try {
//     sessionStorage.setItem(SESSION_KEY, code);
//   } catch {
//     /* ignore */
//   }
// };

// /**
//  * Region picker sends the choice inside the Cognito `state` param. Because login
//  * uses response_type=token, Cognito echoes `state` back in the URL *hash*.
//  * This is the primary path for a first-time login (nothing sticky stored yet).
//  */
// export const detectRegionFromStateParam = () => {
//   const hash = window.location.hash || "";
//   const match = hash.match(/state=([^&]+)/);

//   if (match && match[1]) {
//     try {
//       const stateObj = JSON.parse(decodeURIComponent(match[1]));
//       if (isKnownRegion(stateObj.region)) {
//         persistRegion(stateObj.region);
//         console.log(`Saved region from state param: ${stateObj.region}`);
//         return stateObj.region;
//       }
//     } catch (err) {
//       console.warn("Failed to parse region from state param:", err);
//     }
//   }
//   return null;
// };

// /**
//  * Fallback: infer the region from the Cognito domain in the referrer (or the
//  * current URL). document.referrer is increasingly stripped on cross-origin
//  * redirects, so treat this as best-effort only.
//  */
// export const detectRegionFromCognitoUrl = () => {
//   let urlToCheck = document.referrer || "";
//   if (!urlToCheck.includes("amazoncognito.com")) {
//     urlToCheck = window.location.href;
//   }

//   // Method 1: exact domain match (most reliable).
//   for (const [domain, region] of Object.entries(domainToRegionMap)) {
//     if (urlToCheck.includes(domain)) {
//       persistRegion(region);
//       return region;
//     }
//   }

//   // Method 2: pull the AWS region out of any amazoncognito.com URL.
//   const patterns = [
//     /([a-z0-9-]+[a-z0-9]+)\.auth\.([a-z0-9-]+)\.amazoncognito\.com/,
//     /([a-zA-Z0-9]+)\.auth\.([a-z0-9-]+)\.amazoncognito\.com/,
//     /auth\.([a-z0-9-]+)\.amazoncognito\.com/,
//   ];

//   for (const pattern of patterns) {
//     const m = urlToCheck.match(pattern);
//     if (m) {
//       const awsRegion = m[2] || m[1];
//       const region = awsToBusinessRegionMap[awsRegion];
//       if (isKnownRegion(region)) {
//         persistRegion(region);
//         return region;
//       }
//     }
//   }

//   return null;
// };

// /**
//  * Read the sticky stored region. Returns null if nothing valid is stored.
//  */
// export const getStoredRegion = () => {
//   try {
//     const code = localStorage.getItem(ORIGINAL_KEY);
//     return isKnownRegion(code) ? code : null;
//   } catch {
//     return null;
//   }
// };

// export const setStoredRegion = (code) => {
//   if (!isKnownRegion(code)) throw new Error(`Unknown region: ${code}`);
//   persistRegion(code);
// };

// /**
//  * Call this on sign-out. Clearing the sticky key is what lets a user switch
//  * regions on their next login — otherwise the old region wins forever.
//  */
// export const clearStoredRegion = () => {
//   try {
//     localStorage.removeItem(ORIGINAL_KEY);
//     localStorage.removeItem("userRegion"); // legacy key from older builds
//   } catch {
//     /* ignore */
//   }
//   try {
//     sessionStorage.removeItem(SESSION_KEY);
//   } catch {
//     /* ignore */
//   }
// };

// /**
//  * Resolve the Amplify auth config, in priority order:
//  *   1. sticky stored region (userOriginalRegion)
//  *   2. region from the Cognito `state` param in the URL hash (picker path)
//  *   3. region parsed from the Cognito domain / referrer
//  *   4. region guessed from the hostname
//  *   5. GB fallback
//  *
//  * Async so existing `await getAuthConfig()` callers keep working unchanged.
//  * Note: this always returns a config (never null) — it falls back to GB rather
//  * than showing a picker. If you want the picker instead, have the caller check
//  * getStoredRegion() first and only call this once a region is chosen.
//  */
// export const getAuthConfig = async () => {
//   // 1. Sticky stored region wins (prevents cross-region drift mid-session).
//   let region = getStoredRegion();
//   if (region) {
//     persistRegion(region);
//     return regionConfig[region];
//   }

//   // 2. State param (hash) — how the region picker hands the choice over.
//   region = detectRegionFromStateParam();
//   if (region) return regionConfig[region];

//   // 3. Cognito domain / referrer.
//   region = detectRegionFromCognitoUrl();
//   if (region) return regionConfig[region];

//   // 4. Hostname hints.
//   const hostname = window.location.hostname.toLowerCase();
//   if (hostname.includes("in.")) region = "IN";
//   else if (hostname.includes("us.")) region = "US";
//   else if (hostname.includes("gb.") || hostname.includes("uk.")) region = "GB";

//   if (isKnownRegion(region)) {
//     persistRegion(region);
//     return regionConfig[region];
//   }

//   // 5. Last resort.
//   console.warn(
//     "No region detected — using GB fallback. This may cause cross-region session issues.",
//     { referrer: document.referrer, currentUrl: window.location.href }
//   );
//   persistRegion(DEFAULT_REGION);
//   return regionConfig[DEFAULT_REGION];
// };

// /**
//  * Debug helper: are the sticky and session copies in agreement?
//  */
// export const verifyRegionConsistency = () => {
//   const stored = localStorage.getItem(ORIGINAL_KEY);
//   const session = sessionStorage.getItem(SESSION_KEY);
//   return stored === session;
// };
export const regionConfig = {
  US: {
    aws_project_region: "us-west-2",
    aws_cognito_region: "us-west-2",
    aws_user_pools_id: "us-west-2_Vz5tDjg3y",
    aws_user_pools_web_client_id: "5lj1cimcdk1p89r20ecpcqdh3b",
    oauth: {
      domain: "https://us-west-2vz5tdjg3y.auth.us-west-2.amazoncognito.com",
      scope: ["email", "openid", "phone", "profile"],
      responseType: "code",
      redirectSignIn: "https://support.servqualit.com/",
      redirectSignOut: "https://support.servqualit.com/",
    },
  },
  IN: {
    aws_project_region: "ap-south-1",
    aws_cognito_region: "ap-south-1",
    aws_user_pools_id: "ap-south-1_nbQYwCpEz",
    aws_user_pools_web_client_id: "5tekknmkii3lpsamv4tasmd3ru",
    oauth: {
      domain: "https://ap-south-1nbqywcpez.auth.ap-south-1.amazoncognito.com",
      scope: ["email", "openid", "phone", "profile"],
      responseType: "code",
      redirectSignIn: "https://support.servqualit.com/",
      redirectSignOut: "https://support.servqualit.com/",
    },
  },
  GB: {
    aws_project_region: "eu-west-1",
    aws_cognito_region: "eu-west-1",
    aws_user_pools_id: "eu-west-1_t8wtScXyc",
    aws_user_pools_web_client_id: "50me4qr8qje2pbp7nckaav7a9b",
    oauth: {
      domain: "https://eu-west-1t8wtscxyc.auth.eu-west-1.amazoncognito.com",
      scope: ["email", "openid", "phone", "profile"],
      responseType: "code",
      redirectSignIn: "https://support.servqualit.com/",
      redirectSignOut: "https://support.servqualit.com/",
    },
  },
};

// Order here is the order they appear in the picker.
export const REGIONS = [
  { code: "GB", label: "United Kingdom", detail: "eu-west-1" },
  { code: "US", label: "United States", detail: "us-west-2" },
  { code: "IN", label: "India", detail: "ap-south-1" },
];

export const DEFAULT_REGION = "GB";

/**
 * Derived from regionConfig[*].oauth.domain (host only, no https://).
 * Keep in sync whenever you add, remove, or rename a pool.
 */
const domainToRegionMap = {
  "us-west-2vz5tdjg3y.auth.us-west-2.amazoncognito.com": "US",
  "ap-south-1nbqywcpez.auth.ap-south-1.amazoncognito.com": "IN",
  "eu-west-1t8wtscxyc.auth.eu-west-1.amazoncognito.com": "GB",
};

// AWS region -> business region. Unambiguous here (one pool per AWS region).
const awsToBusinessRegionMap = {
  "us-west-2": "US",
  "ap-south-1": "IN",
  "eu-west-1": "GB",
};

// Sticky, authoritative choice — survives the Cognito redirect and browser restarts.
const ORIGINAL_KEY = "userOriginalRegion";
// Per-session mirror, kept for anything that still reads the old key.
const SESSION_KEY = "userRegion";

const isKnownRegion = (code) => !!code && !!regionConfig[code];

const persistRegion = (code) => {
  try {
    localStorage.setItem(ORIGINAL_KEY, code);
  } catch {
    /* private mode / storage disabled */
  }
  try {
    sessionStorage.setItem(SESSION_KEY, code);
  } catch {
    /* ignore */
  }
};

/**
 * Region picker sends the choice inside the Cognito `state` param. Because login
 * uses response_type=token, Cognito echoes `state` back in the URL *hash*.
 * This is the primary path for a first-time login (nothing sticky stored yet).
 */
export const detectRegionFromStateParam = () => {
  const hash = window.location.hash || "";
  const match = hash.match(/state=([^&]+)/);

  if (match && match[1]) {
    try {
      const stateObj = JSON.parse(decodeURIComponent(match[1]));
      if (isKnownRegion(stateObj.region)) {
        persistRegion(stateObj.region);
        console.log(`Saved region from state param: ${stateObj.region}`);
        return stateObj.region;
      }
    } catch (err) {
      console.warn("Failed to parse region from state param:", err);
    }
  }
  return null;
};

/**
 * Fallback: infer the region from the Cognito domain in the referrer (or the
 * current URL). document.referrer is increasingly stripped on cross-origin
 * redirects, so treat this as best-effort only.
 */
export const detectRegionFromCognitoUrl = () => {
  let urlToCheck = document.referrer || "";
  if (!urlToCheck.includes("amazoncognito.com")) {
    urlToCheck = window.location.href;
  }

  // Method 1: exact domain match (most reliable).
  for (const [domain, region] of Object.entries(domainToRegionMap)) {
    if (urlToCheck.includes(domain)) {
      persistRegion(region);
      return region;
    }
  }

  // Method 2: pull the AWS region out of any amazoncognito.com URL.
  const patterns = [
    /([a-z0-9-]+[a-z0-9]+)\.auth\.([a-z0-9-]+)\.amazoncognito\.com/,
    /([a-zA-Z0-9]+)\.auth\.([a-z0-9-]+)\.amazoncognito\.com/,
    /auth\.([a-z0-9-]+)\.amazoncognito\.com/,
  ];

  for (const pattern of patterns) {
    const m = urlToCheck.match(pattern);
    if (m) {
      const awsRegion = m[2] || m[1];
      const region = awsToBusinessRegionMap[awsRegion];
      if (isKnownRegion(region)) {
        persistRegion(region);
        return region;
      }
    }
  }

  return null;
};

/**
 * Read the sticky stored region. Returns null if nothing valid is stored.
 */
export const getStoredRegion = () => {
  try {
    const code = localStorage.getItem(ORIGINAL_KEY);
    return isKnownRegion(code) ? code : null;
  } catch {
    return null;
  }
};

export const setStoredRegion = (code) => {
  if (!isKnownRegion(code)) throw new Error(`Unknown region: ${code}`);
  persistRegion(code);
};

/**
 * Call this on sign-out. Clearing the sticky key is what lets a user switch
 * regions on their next login — otherwise the old region wins forever.
 */
export const clearStoredRegion = () => {
  try {
    localStorage.removeItem(ORIGINAL_KEY);
    localStorage.removeItem("userRegion"); // legacy key from older builds
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
};

/**
 * Resolve the Amplify auth config, in priority order:
 *   1. sticky stored region (userOriginalRegion)
 *   2. region from the Cognito `state` param in the URL hash (picker path)
 *   3. region parsed from the Cognito domain / referrer
 *   4. region guessed from the hostname
 *   5. GB fallback
 *
 * Async so existing `await getAuthConfig()` callers keep working unchanged.
 * Note: this always returns a config (never null) — it falls back to GB rather
 * than showing a picker. If you want the picker instead, have the caller check
 * getStoredRegion() first and only call this once a region is chosen.
 */
export const getAuthConfig = async () => {
  // 1. Sticky stored region wins (prevents cross-region drift mid-session).
  let region = getStoredRegion();
  if (region) {
    persistRegion(region);
    return regionConfig[region];
  }

  // 2. State param (hash) — how the region picker hands the choice over.
  region = detectRegionFromStateParam();
  if (region) return regionConfig[region];

  // 3. Cognito domain / referrer.
  region = detectRegionFromCognitoUrl();
  if (region) return regionConfig[region];

  // 4. Hostname hints.
  const hostname = window.location.hostname.toLowerCase();
  if (hostname.includes("in.")) region = "IN";
  else if (hostname.includes("us.")) region = "US";
  else if (hostname.includes("gb.") || hostname.includes("uk.")) region = "GB";

  if (isKnownRegion(region)) {
    persistRegion(region);
    return regionConfig[region];
  }

  // 5. Last resort.
  console.warn(
    "No region detected — using GB fallback. This may cause cross-region session issues.",
    { referrer: document.referrer, currentUrl: window.location.href },
  );
  persistRegion(DEFAULT_REGION);
  return regionConfig[DEFAULT_REGION];
};

/**
 * Debug helper: are the sticky and session copies in agreement?
 */
export const verifyRegionConsistency = () => {
  const stored = localStorage.getItem(ORIGINAL_KEY);
  const session = sessionStorage.getItem(SESSION_KEY);
  return stored === session;
};
